import { render, staticRenderFns } from "./Invoicee.vue?vue&type=template&id=48bcf691&scoped=true&"
import script from "./Invoicee.vue?vue&type=script&lang=js&"
export * from "./Invoicee.vue?vue&type=script&lang=js&"
import style0 from "./Invoicee.vue?vue&type=style&index=0&id=48bcf691&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bcf691",
  null
  
)

export default component.exports